export default __webpack_public_path__ + "static/project-slide-6-2016-765-8af2719dc7ff71d1238fef176ae8dc18.webp";